<template>
  <span class="def-inform-text">
    <teleport to="#informText">
      <Transition name="fade">
        <span
          v-if="isShowText"
          ref="content"
          :class="`${contentClasses}`"
          class="def-inform-text__content"
          :style="contentStyles"
        >
          <slot name="content" />
        </span>
      </Transition>
    </teleport>

    <span
      ref="inform"
      class="def-inform-text__inform"
      @mouseenter="isShowText = true"
      @mouseleave="isShowText = false"
    >
      <slot />
    </span>
  </span>
</template>

<script>
export default {
  name: 'DefInformText',
  props: ['result', 'parent'],
  data: () => ({
    isShowText: false,
    contentClasses: '',
    contentStyles: {
      // top: '50px',
    },
  }),
  watch: {
    async isShowText(newValue) {
      try {
        if (newValue) {
          // const parent = document.querySelector(this.parent);
          // if (parent) {
          //     this.contentClasses = '';
          //     const { left, top, width, height } = this.$refs.inform.getBoundingClientRect();
          // const informRight = parent.offsetWidth - left - width;
          // const informBottom = parent.offsetHeight - top - height;

          // await this.$nextTick();

          // const contentWidth = this.$refs.content.offsetWidth;
          // const contentHeight = this.$refs.content.offsetHeight;

          // по вертикали
          // if (top - parent.offsetTop < contentHeight + 20) {
          //     /** контент с верху страницы **/
          //     this.contentStyles.top = top + height + 20  + 'px';
          //     this.contentStyles.left = left - 10 + 'px';
          //     this.contentClasses += 'def-inform-text__top ';
          //     console.log(1);
          // } else if (informBottom < contentHeight) {
          //     /** контент в низу страницы **/
          //     this.contentClasses += 'def-inform-text__bottom ';
          //     console.log(2);
          // }
          //
          // // по горизонтали
          // if (left < contentWidth) {
          //     /** контент с лева **/
          //     this.contentStyles.left = left + 'px';
          //     this.contentStyles.top = top - contentHeight - 20 + scrollY  + 'px';
          //     console.log(3);
          // } else if (informRight < contentWidth) {
          //     /** контент с права **/
          //     this.contentClasses += 'def-inform-text__right ';
          //     console.log(4);
          // }

          // } else {
          this.contentClasses = '';
          const { left, top, width, height } = this.$refs.inform.getBoundingClientRect();
          const { screen } = window;

          const informRight = screen.width - left - width;
          const informBottom = screen.height - top - height;

          await this.$nextTick();

          const contentWidth = this.$refs.content.offsetWidth;
          const contentHeight = this.$refs.content.offsetHeight;

          this.contentStyles.top = `${top - contentHeight - 20 + window.scrollY}px`;
          this.contentStyles.left = `${left}px`;
          // по вертикали
          if (top < contentHeight) {
            /** контент с верху страницы * */
            // this.contentClasses += 'def-inform-text__top ';
            this.contentStyles.top = `${top + window.scrollY + height + 20}px`;
            this.contentStyles.left = `${left - 10}px`;
            this.contentClasses += 'def-inform-text__top ';
            // console.log(1);
          } else if (informBottom < contentHeight) {
            /** контент в низу страницы * */
            this.contentClasses += 'def-inform-text__bottom ';
            // console.log(2);
          }

          // по горизонтали
          // if (left < contentWidth) {
          //     /** контент с лева **/
          //     // this.contentClasses += 'def-inform-text__left ';
          //     this.contentStyles.left = left + 'px';
          //     console.log(3);
          // } else if (informRight < contentWidth) {
          //     /** контент с права **/
          //     this.contentClasses += 'def-inform-text__right ';
          //     console.log(4);
          // }
          // }
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-inform-text {
  position: relative;
  &__content {
    position: absolute;
    padding: 8px;
    font-size: rem(14);
    line-height: 115%;
    background: var(--background-beige);
    //bottom: calc(100% + 10px);
    z-index: 1001;
    width: 100vw;
    max-width: 154px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      transform: translateY(100%);
      border: 5px solid transparent;
      border-top-color: var(--background-beige);
      border-left-color: var(--background-beige);
    }
  }
  &__inform {
    cursor: pointer;
  }
  &__top {
    &:after {
      transform: translateY(-100%);
      top: 0;
      bottom: unset;
      border-top-color: transparent;
      border-bottom-color: var(--background-beige);
      border-left-color: transparent;
      border-right-color: var(--background-beige);
    }
  }
  &__left {
    left: 3px;
  }
  &__right {
    right: calc(100% - 20px);
    &:after {
      right: 8px;
      border-left-color: transparent;
      border-right-color: var(--background-beige);
    }
  }
}
</style>
